import * as React from "react";
import {
  useTabState,
  Tab as BaseTab,
  TabList as BaseTabList,
  TabListOptions,
  TabPanel as BaseTabPanel,
  TabProps,
  TabPanelOptions,
} from "reakit/Tab";

import classNames from "classnames";

const TabsContext = React.createContext<
  undefined | ReturnType<typeof useTabState>
>(undefined);

type TabsProps = Exclude<Parameters<typeof useTabState>[0], Function>;

export const Tabs: React.FC<Partial<TabsProps>> = ({
  children,
  ...initialState
}) => {
  const tab = useTabState(initialState);
  const value = React.useMemo(() => tab, Object.values(tab));
  return <TabsContext.Provider value={value}>{children}</TabsContext.Provider>;
};

export const Tab: React.FC<Partial<TabProps>> = (props) => {
  const tab = React.useContext(TabsContext);
  return <BaseTab {...tab} className={classNames("nav-link")} {...props} />;
};

export const TabList: React.FC<Partial<TabListOptions>> = (props) => {
  const tab = React.useContext(TabsContext);

  return (
    <BaseTabList
      {...tab}
      // as="nav"
      className="nav nav-tabs"
      css={`
        border-color: ${(p) => p.theme.gray300};
      `}
      // wrap={"horizontal"}
      {...props}
    />
  );
};

export const TabPanel: React.FC<Partial<TabPanelOptions>> = (props) => {
  const tab = React.useContext(TabsContext);
  return <BaseTabPanel {...tab} {...props} />;
};
